<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <!---
    <search-bar />
--->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- notification
      <notification-dropdown />
      --->
      <b-nav-item-dropdown
        v-if="currentAuthenticatedUser !== null"
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >

        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ currentAuthenticatedUser.attributes.email }}
            </p>
            <!-- Role and workspace -->
            <span class="user-status">
              {{ currentRole }}
            </span>
            <span class="user-status">{{ currentWorkspaceName }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="require('@/assets/images/avatars/13-small.png')"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="switchWorkspaceModal"
        >
          <span>Switch Workspace</span>
        </b-dropdown-item>

        <b-dropdown-item
          :to="{ name: 'settingsPage'}"
          link-class="d-flex align-items-center"
        >
          <span>Account Settings</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          disabled
        >
          <span>Version: {{ version }} </span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="signOut"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-modal
      ref="my-modal"
      size="xl"
      hide-footer
      title="Switch Workspace"
    >
      <div class="border-bottom">
        <b-table
          v-if="workspaces && workspaces.length > 0"
          :tbody-tr-class="rowClass"
          :items="workspacesAndRoles"
          :fields="workspaceFields"
        >
          <template #cell(name)="data">

            {{ workspaces.find(workspace => workspace.id === data.item.id).name }}

          </template>
          <template #cell(role)="data">
            <b-badge
              :variant="highestRoleVariant(data.item.roles)"
            >
              {{ highestRole(data.item.roles).toUpperCase() }}
            </b-badge>
          </template>
          <template #cell(action)="data">
            <div
              v-if="data.item.id===currentWorkspace.id"
            />
            <b-button
              v-else
              variant="primary"
              @click="switchWorkspace(data.item)"
            >
              Switch
            </b-button>
          </template>
        </b-table>
      </div>

      <b-button
        class="mt-1"
        variant="primary"
        @click="createWorkspaceModal"
      >
        Create Workspace
      </b-button>

    </b-modal>

    <b-modal
      ref="create-workspace-modal"
      hide-footer
      title="Create Workspace"
    >
      <div class="d-block text-center">
        <b-form-input
          v-model="createWorkspaceName"
          placeholder="Workspace Name"
        />

        <div
          v-if="createWorkspaceError"
          class="mt-2 text-danger"
        >
          {{ createWorkspaceError }}
        </div>

        <b-button
          class="mt-1"
          variant="primary"
          @click="createWorkspace"
        >
          Create
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BModal,
  BTable,
  BButton,
  BFormInput,
  BBadge,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { Auth, API } from 'aws-amplify'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { AbilityBuilder, Ability } from '@casl/ability'
import datadogLogs from '@datadog/browser-logs'
import useJwt from '@/auth/jwt/useJwt'
// import NotificationDropdown from './NotificationDropdown.vue'
// import SearchBar from './SearchBar.vue'
import * as queries from '../../graphql/queries'
import { version } from '../../../package.json'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    // NotificationDropdown,
    BModal,
    BTable,
    BButton,
    BFormInput,
    // Navbar Components
    DarkToggler,
    // SearchBar,
    BBadge,

  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      version,
      userName: '',
      currentAuthenticatedUser: null,
      userData: {},

      // From Localstorage
      localWorkspace: '',
      // From API
      currentWorkspaceName: '',
      currentWorkspace: {},
      currentRole: '',
      currentRoles: '',
      workspaces: [],
      cognitoRoles: [],
      cognitoGroups: [],
      workspacesAndRoles: [],
      workspaceFields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'role', label: 'Role', sortable: true },
        { key: 'action', label: '' },
      ],
      createWorkspaceName: '',
      createWorkspaceError: '',
    }
  },
  created() {
    this.listWorkspaces()
    this.getWorkspaceAndRole()
  },
  methods: {
    rowClass(item) {
      return {
        'bg-success': item.id === this.currentWorkspace.id,
      }
    },
    async createWorkspaceModal() {
      this.$refs['create-workspace-modal'].show()
    },
    /*
    async createWorkspace() {
      try {
        const authUser = await Auth.currentAuthenticatedUser()

        if (!authUser) {
          this.createWorkspaceError = 'User not authenticated'
          return
        }

        const { createWorkspaceName } = this

        if (!createWorkspaceName || createWorkspaceName.trim() === '') {
          this.createWorkspaceError = 'Workspace name cannot be empty'
          return
        }

        const apiName = 'AdminQueries'
        const path = '/createWorkspace'
        const myInit = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
          },
          body: {
            name: createWorkspaceName,
            username: authUser.username,
          },
        }

        try {
          const response = await API.post(apiName, path, myInit)
          this.createWorkspaceError = response
        } catch (apiError) {
          this.createWorkspaceError = `Failed to create the workspace: ${apiError}`
        }
      } catch (error) {
        this.createWorkspaceError = error.message
      }
    },
*/
    async createWorkspace() {
      const authUser = await Auth.currentAuthenticatedUser()
      const { createWorkspaceName } = this
      const apiName = 'workspaceApi'
      const path = '/workspaces'
      const myInit = {
        body: {
          name: createWorkspaceName,
          username: authUser.username,
        },
      }

      await API.post(apiName, path, myInit).then(() => {
        localStorage.removeItem('workspace')
        this.signOut()
      })
    },

    async getWorkspaceAndRole() {
      this.localWorkspace = JSON.parse(localStorage.getItem('workspace'))

      // Get the workspace name
      await API.graphql({
        query: queries.getWorkspace,
        variables: { id: this.localWorkspace.id },
      }).then(res => {
        this.currentWorkspace = res.data.getWorkspace
        this.currentWorkspaceName = res.data.getWorkspace.name
      })

      this.currentAuthenticatedUser = await Auth.currentAuthenticatedUser()
      this.cognitoGroups = this.currentAuthenticatedUser.signInUserSession.accessToken.payload['cognito:groups']

      let workspaceIndex = 0
      this.cognitoGroups.forEach((workspace => {
        // workspace is a string containing the workspace id and role name
        // get the workspace id
        const workspaceId = workspace.substring(0, workspace.indexOf('.'))
        // check if the workspace id is already in the workspacesAndRoles array
        workspaceIndex = this.workspacesAndRoles.findIndex(w => w.id === workspaceId)
        if (workspaceIndex > -1) {
          // if the workspace id is already in the workspacesAndRoles array, push the role to the roles array
          this.workspacesAndRoles[workspaceIndex].roles.push(workspace.substring(workspace.indexOf('.') + 1))
        } else {
          // if the workspace id is not in the workspacesAndRoles array, create a new object and push it to the array
          this.workspacesAndRoles.push({
            id: workspaceId,
            roles: [workspace.substring(workspace.indexOf('.') + 1)],
          })
        }
      }))
      // Get Roles that matches the current workspace
      this.cognitoGroups.forEach(group => {
        const groupId = group.split('.')[0]
        if (groupId === this.currentWorkspace.id) {
          this.cognitoRoles.push(group.split('.')[1])
        }
      })
      // Get the highest priority role
      this.currentRole = this.highestRole(this.cognitoRoles)
    },
    highestRole(roles) {
      // roles is an array of roles
      // return the highest role
      if (roles.includes('admin')) {
        return 'Admin'
      } if (roles.includes('editor')) {
        return 'Editor'
      } if (roles.includes('viewer')) {
        return 'Viewer'
      }
      return ''
    },
    highestRoleVariant(roles) {
      // roles is an array of roles
      // return the highest role
      if (roles.includes('admin')) {
        return 'danger'
      } if (roles.includes('editor')) {
        return 'warning'
      } if (roles.includes('viewer')) {
        return 'success'
      }
      return ''
    },
    switchWorkspaceModal() {
      this.$refs['my-modal'].show()
    },
    async switchWorkspace(workspace) {
      // eslint-disable-next-line no-unused-vars

      if (workspace.name !== undefined) {
        const workspaceName = workspace.name
        localStorage.setItem('workspace', JSON.stringify({ id: workspace.id, name: workspaceName }))
      } else {
        const workspaceName = this.workspaces.find(w => w.id === workspace.id).name
        localStorage.setItem('workspace', JSON.stringify({ id: workspace.id, name: workspaceName }))
      }
      const workspaceRole = this.highestRole(this.workspacesAndRoles.find(w => w.id === workspace.id).roles)
      // Set the ability based on the role
      const { can, cannot, rules } = new AbilityBuilder(Ability)
      if (workspaceRole.toLowerCase() === 'admin') {
        can('manage', 'all')
      } else if (workspaceRole.toLowerCase() === 'editor') {
        can('manage', 'all')
        cannot('manage', 'workspace')
      } else if (workspaceRole.toLowerCase() === 'viewer') {
        can('read', 'all')
      }
      // userData.ability = rules
      this.$ability.update(rules)

      // Set Token
      // useJwt.setToken(userData.signInUserSession.accessToken.jwtToken)
      // useJwt.setRefreshToken(userData.signInUserSession.refreshToken.token)

      // localStorage.setItem('userData', JSON.stringify(userData))

      // Refresh page
      window.location.reload()
    },
    async listWorkspaces() {
      try {
        await API.graphql({
          query: queries.listWorkspaces,
        }).then(res => {
          this.workspaces = res.data.listWorkspaces.items
        })
      } catch (error) {
        datadogLogs.logger.error('Error listing workspaces', error)
      }
    },
    async signOut() {
      try {
        // eslint-disable-next-line no-unused-vars
        const resp = await Auth.signOut()

        // Remove userData from localStorage
        // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
        localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
        localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

        // Remove userData from localStorage
        localStorage.removeItem('userData')

        // Reset ability
        // this.$ability.update(initialAbility)

        // Redirect to login page
        this.$router.push({ name: 'auth-login' })
      // eslint-disable-next-line no-empty
      } catch (error) {
      }
    },
  },
}
</script>
